import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'endpointsFilter2'
})
export class EndpointsFilter2Pipe implements PipeTransform {
    constructor() {}
    transform(endpoints, filters) {
        if (filters[0]) {
            return endpoints.filter(e => {
                if (e.register.activeCalls > 0) {
                    return e;
                }
            });
        } else if (filters[1]) {
            return endpoints.filter(e => {
                if (e.register.activeCalls == 0 && e.register.plcmH323Identity && e.register.plcmH323Identity.h323RegistrationState == 'ACTIVE') {
                    return e;
                }
                if (e.register.activeCalls == 0 && e.register.plcmSipIdentityV2 && e.register.plcmSipIdentityV2.sipRegistrationState == 'ACTIVE') {
                    return e;
                }
            });
        } else if (filters[2]) {
            return endpoints.filter(e => {
                if (e.register.plcmH323Identity && e.register.plcmH323Identity.h323RegistrationState == 'QUARANTINED') {
                    return e;
                }
                if (e.register.plcmSipIdentityV2 && e.register.plcmSipIdentityV2.sipRegistrationState == 'QUARANTINED') {
                    return e;
                }
            });
        } else if (filters[3]) {
            return endpoints.filter(e => {
                if (e.register.activeCalls == 0 && e.register.plcmH323Identity && e.register.plcmH323Identity.h323RegistrationState == 'INACTIVE') {
                    return e;
                }
                if (e.register.activeCalls == 0 && e.register.plcmSipIdentityV2 && e.register.plcmSipIdentityV2.sipRegistrationState == 'INACTIVE') {
                    return e;
                }
            });
        } else if (filters[4]) {
            return endpoints.filter(e => {
                if (e.register.plcmH323Identity && e.register.plcmH323Identity.h323RegistrationState == 'QUARANTINED_INACTIVE') {
                    return e;
                }
                if (e.register.plcmSipIdentityV2 && e.register.plcmSipIdentityV2.sipRegistrationState == 'QUARANTINED_INACTIVE') {
                    return e;
                }
            });
        }
        return endpoints;
    }

}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeEndpointsFilter2.ts